<template>
  <div class="page">
    <div class="centered-box locations-white locations-generic">
      <div class="row">
        <div class="col-md">
          <div class="locations-title">HOURLY RENTAL</div>
          (all boats prorated at $20 per hour beyond the first hour)
          <br><br>
          <two-label firstLabel="Canoe" secondLabel="$30" />
          <two-label firstLabel="Single Kayak" secondLabel="$25" />
          <two-label firstLabel="Tandem Kayak" secondLabel="$35" />
          <two-label firstLabel="Row Boat" secondLabel="$30" />
          <!-- <div>
            AFTER WORK SPECIAL (Tuesday through Friday; Clark Park Boathouse only)—20% discount on boats rented and launched after 5:00 p.m.
          </div> -->
          <span class="larger-font">
            Fishing boat (with battery and trolling motor) <strong>–</strong> $30 per hour, with a 2-hour minimum. <span class="red">FISHING BOATS CURRENTLY UNAVAILABLE</span>
          </span>
          <br /><br />
          <two-label
            firstLabel="Monday Discount"
            secondLabel="reduced per first-hour (except Public Holidays)"
          />
          <two-label firstLabel="Canoe" secondLabel="$25" />
          <two-label firstLabel="Single Kayak" secondLabel="$20" />
          <two-label firstLabel="Tandem Kayak" secondLabel="$30" />
          <two-label firstLabel="Row Boat" secondLabel="$25" />
        
        <br>
          <span class="larger-font">
            Fishing boat (with battery and trolling motor) <strong>–</strong> $50 two-hour minimum.
            Beyond two hours, prorated at $20 per hour.
          </span>
          <br />
          <two-label
            class="mt-2"
            firstLabel="Paddle Card"
            secondLabel="Fifth visit FREE after four paid visits (some restrictions apply) "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TwoLabel from "./TwoLabel";
export default {
  name: "Pricing",
  props: {
    msg: String
  },
  components: {
    TwoLabel
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.red {
  color: red;
}
.page {
  background-image: url("../assets/kayak2.jpg");
  flex-direction: column;
}
.larger-font {
  font-size: 18px;
}
.locations-title {
  text-align: left;
}

</style>
